import { render, staticRenderFns } from "./marketStatus.vue?vue&type=template&id=2887ae98&scoped=true&"
import script from "./marketStatus.vue?vue&type=script&lang=js&"
export * from "./marketStatus.vue?vue&type=script&lang=js&"
import style0 from "./marketStatus.vue?vue&type=style&index=0&id=2887ae98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887ae98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2887ae98')) {
      api.createRecord('2887ae98', component.options)
    } else {
      api.reload('2887ae98', component.options)
    }
    module.hot.accept("./marketStatus.vue?vue&type=template&id=2887ae98&scoped=true&", function () {
      api.rerender('2887ae98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/marketStatus/marketStatus.vue"
export default component.exports